module.exports = __webpack_public_path__ + "static/img/12.9cb9334.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/12.png
// module id = FdgC
// module chunks = 0